var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-wrapper"},[_c('div',{class:[
    'ag-theme-balham',
    _vm.isDark ? 'ag-theme-balham-dark' : '',
    'ag-grid-container'
  ]},[_c('ag-grid-vue',{staticClass:"ag-grid",staticStyle:{"width":"100%","height":"100%"},attrs:{"columnDefs":_vm.columnDefs,"rowData":_vm.rowData,"defaultColDef":{ resizable: true },"pagination":true,"paginationPageSize":8,"domLayout":'autoHeight'},on:{"grid-ready":_vm.onGridReady}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }